export class ActionTypeIsNotSupportedError extends Error {
  constructor(message) {
    super(message);
    this.name = 'ActionTypeIsNotSupportedError';
  }
}
